import { FILE_PREVIEW_EXTENSION_MAP, type FilePreviewExtensionName } from '~/components/v2/constants/filePreview';

export const isValidFilePreviewExtension = (ext: string): ext is FilePreviewExtensionName => {
  return Object.keys(FILE_PREVIEW_EXTENSION_MAP).includes(ext);
};
